import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface IProps {
  handleChange: (token: string | null) => void;
}

function ReCAPTCHAForm(props: IProps) {
  return (
    <ReCAPTCHA sitekey={process.env.REACT_APP__RECAPTCHA_KEY || ""} onChange={props.handleChange} />
  );
}

export default ReCAPTCHAForm;
